export const constant = {
  LAPTOP: 'Laptop/Learning Device',
  DATA: 'Data/Internet Subscription',
  COURSE: 'Course/Certification Fees'
};

export const TestId ={
  COMPONENT_TEST_ID:"step2_Component_id"
}